import React from 'react'
import { fetchVisionModeratorEnabled } from '../services/visionModeratorService'

export function useVisionModeratorEnabled(active = true) {
  const [enabled, setEnabled] = React.useState<boolean | null>(null)

  React.useEffect(() => {
    if (!active) {
      setEnabled(false)
      return
    }

    let mounted = true
    ;(async () => {
      try {
        const ok = await fetchVisionModeratorEnabled()
        if (!mounted) return
        setEnabled(ok)
      } catch {
        if (!mounted) return
        setEnabled(false)
      }
    })()

    return () => {
      mounted = false
    }
  }, [active])

  return enabled
}
